import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, ...p }) => (
  <span
    className="inline-block text-xs uppercase tracking-[0.32em] text-bronze font-semibold font-sans"
    {...p}
  >
    {children}
  </span>
);
